
export const numbers = {
    addGapsBetweenPlaces(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
    },
    formatMoney(number, currency) {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency,
        }).format(number)
    }
}